module.exports = __webpack_public_path__ + "static/history3-3ec484b04dca2258979abcb3ab9881a9.jpg";